import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState } from '../stores'
import { removeNotification } from '../stores/NotificationStore'
import styled from 'styled-components'

const NotificationsContainer = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 350px;
`

const NotificationItem = styled.div<{ type: 'info' | 'success' | 'warning' | 'error' }>`
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  animation: slideIn 0.3s ease-out;

  background-color: ${({ type }) => {
    switch (type) {
      case 'success':
        return '#10B981'
      case 'error':
        return '#EF4444'
      case 'warning':
        return '#F59E0B'
      default:
        return '#3B82F6'
    }
  }};

  @keyframes slideIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
`

const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  margin-left: 10px;
  opacity: 0.7;
  transition: opacity 0.2s;

  &:hover {
    opacity: 1;
  }
`

const Notifications: React.FC = () => {
  const dispatch = useDispatch()
  const notifications = useSelector((state: RootState) => state.notification.notifications)

  useEffect(() => {
    // Auto-remove notifications after their duration expires
    const timers: ReturnType<typeof setTimeout>[] = []
    notifications.forEach((notification) => {
      if (notification.duration > 0) {
        timers.push(setTimeout(() => {
          dispatch(removeNotification(notification.id))
        }, notification.duration))
      }
    })
    return () => timers.forEach(clearTimeout)
  }, [notifications, dispatch])

  if (notifications.length === 0) return null

  return (
    <NotificationsContainer>
      {notifications.map((notification) => (
        <NotificationItem key={notification.id} type={notification.type}>
          <div>{notification.message}</div>
          <CloseButton onClick={() => dispatch(removeNotification(notification.id))}>✕</CloseButton>
        </NotificationItem>
      ))}
    </NotificationsContainer>
  )
}

export default Notifications
